import Button from "components/Button/Button";
import React from "react";
import moment from 'moment';

// import PieChartBox from "../../Dashboard/components/PieChartBox/PieChartBox";
// import LineChartBox from "../../Dashboard/components/LineChartBox/LineChartBox";

import styles from "./OneOrgHeader.module.scss";
import Dropdown from "../../../components/Dropdown/Dropdown";

import { connect } from "react-redux"
import { setGrantSealAction } from 'store/actions/Actions';

import TableDefAffiliates from "table-defs/TableDefAffiliates";
import TableDefAllUsers from "table-defs/TableDefAllUsers";
import TableDefAudits from "table-defs/TableDefAudits";
import TableDefRemediation from "table-defs/TableDefRemediation";
import TableDefIncidents from "table-defs/TableDefIncidents";
import TableDefTraining from "table-defs/TableDefTraining";
import TableDefTasks from "table-defs/TableDefTasks";

// import AppLayoutWrapFull from "components/AppLayoutWrapFull";
// import InfoPanel from "components/InfoPanel/InfoPanel";

// import PageHeader from "components/PageHeader/PageHeader";

// import { submitUserSettingsFormAction, loadUserSettingsFormAction } from "store/actions/Actions";

const OneOrgHeader = (props) => {

  const { org, setGrantSealAction, UserOrgSiteReducer, callbackFun } = props;

  // Put #1 for tab1's total and #2 to tab2's total
  const dropdownOptions = [
    { id: '1', label: 'All info panels', toggleAll: true, checked: true },
    { id: '2', label: 'Statistics', checked: true },
    { id: '3', label: 'Overall Progress', checked: true },
    { id: '4',  link: '/maintain/users', rowDataProperty: 'unregistered_users', label: 'Users', key: 'users', tab1: 'All Users (#1)', tab2: 'Unregistered Users (#2)', tableDefinition: TableDefAllUsers,  checked: true },
    { id: '5',  link: '/achieve/affiliates', rowDataProperty: 'under_review_affiliates', label: 'Affiliates', key: 'affiliates', tab1: 'All Affiliates (#1)', tab2: 'Under Review (#2)', tableDefinition: TableDefAffiliates, checked: true },
    { id: '6',  link: '/achieve/audits', label: 'Recent Audits', key: 'audits', tab1: 'All Audits (#1)', tab2: undefined, tableDefinition: TableDefAudits, checked: true },
    { id: '7',  link: '/achieve/remediation', label: 'Remediation', key: 'remediations', tab1: 'All Remediations (#1)', tab2: undefined, tableDefinition: TableDefRemediation, checked: true },
    { id: '8',  link: '/maintain/incidents', label: 'Incidents', key: 'incidents', tab1: 'All Incidents (#1)', tab2: undefined, tableDefinition: TableDefIncidents, checked: true },
    { id: '9',  link: '/achieve/training', label: 'Trainings', key: 'trainings', tab1: 'All Trainings (#1)', tab2: undefined, tableDefinition: TableDefTraining, checked: true },
    { id: '10', link: '/achieve/tasks', label: 'Tasks', key: 'tasks', tab1: 'All Tasks (#1)', tab2: undefined, tableDefinition: TableDefTasks, checked: true },
  ];

  const onDropdownChange = (dropdownOptions) => {
    callbackFun(dropdownOptions);
  }

  return (
    <div className={styles.org_header}>
      <div className={styles.top}>
        {/* <div>back</div> */}
        <div className={styles.org_name}>{org.org_name}</div>
        {/* <div>status</div> */}
        <div className={styles.right}>
          <div>
            <Button
                icon="fal fa-file-certificate"
                size="md"
                text="GRANT SEAL"
                className={styles.create}
                onClick={() => setGrantSealAction({orgId: UserOrgSiteReducer.selected.org})}
            />
          </div>
          {/* <div style={{ marginLeft: 10 }}>
            <Button
                icon="fal fa-at"
                size="md"
                text="SEND NOTIFICATION"
                className={styles.create}
                onClick={() => console.log('abcd')}
            />
          </div> */}
        </div>
      </div>
      <div className={styles.bottom}>
        <div>
          <div><strong>Seal Expire date:</strong> {org.seal_granted_at ? moment(org.seal_granted_at).format('MM/DD/YYYY') : '-'}</div>
          <div><strong>Coach:</strong> {org.coach_name}</div>
        </div>
        <div className={styles.settings}>
          <Dropdown 
            button 
            configuration 
            options={dropdownOptions} 
            dropdownHeader
            dropdowHeaderTitle="DASHBOARD SETTINGS / SHOW"
            multipleSelect
            onChange={onDropdownChange}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
  setGrantSealAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OneOrgHeader);
